"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeospatialAccuracy = void 0;
const core_1 = require("@openhps/core");
let GeospatialAccuracy = class GeospatialAccuracy extends core_1.Accuracy {
    constructor(space) {
        super(space, core_1.LengthUnit.METER);
    }
    toString() {
        return this.value.displayName;
    }
    valueOf() {
        return this.value
            .getBounds()
            .map((pos) => this.value.centroid.distanceTo(pos))
            .reduce((a, b) => Math.max(a, b), 0);
    }
};
exports.GeospatialAccuracy = GeospatialAccuracy;
exports.GeospatialAccuracy = GeospatialAccuracy = __decorate([
    (0, core_1.SerializableObject)(),
    __metadata("design:paramtypes", [Object])
], GeospatialAccuracy);
//# sourceMappingURL=GeospatialAccuracy.js.map